import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/api";
import { setLoading } from "../../loading/loadingSlice";

export const getAddConsumableList = createAsyncThunk("getAddConsumableList", async ({ page, limit, search, searchFields }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const params = {
      page: page ?? 1,
      limit: limit ?? 10,
      search,
      searchFields: searchFields ?? "itemName,code",
    };
    const response = await api.get(`/api/v1/cc/nursing_care/additional_consumables`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const editConsumable = createAsyncThunk("editConsumable", async ({ body, userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.patch(`/api/v1/cc/nursing_care/additional_consumables/${userId}`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error updating :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error updating";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const deleteConsumable = createAsyncThunk("deleteConsumable", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.delete(`/api/v1/cc/nursing_care/additional_consumables/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleteing :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error deleteing";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getAllGroups = createAsyncThunk("getAllGroups", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.get(`/api/v1/cc/nursing_care/additional_consumables/groups`);
    return response.data;
  } catch (error) {
    console.error("Error getting list :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const createConsumable = createAsyncThunk("createConsumable", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.post(`/api/v1/cc/nursing_care/additional_consumables`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error creating consumable :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating consumable";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const createGroup = createAsyncThunk("createGroup", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));

    const response = await api.post(`/api/v1/cc/nursing_care/additional_consumables/groups`, { ...body });
    return response.data;
  } catch (error) {
    console.error("Error creating group :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating group";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const getBillingRequests = createAsyncThunk("getBillingRequests", async ({ page = 1, limit = 10, status, search, searchFields, silent = false }, { dispatch }) => {
  try {
    if (!silent) dispatch(setLoading(true));
    const params = { page, limit, status };
    if (search) {
      params.search = search;
      params.searchFields = searchFields || "patient.fullName,relative.hnNumber,patient.hnNumber";
    }
    const response = await api.get(`/api/v1/cc/nursing_care/additional_consumables/requests_with_consumables`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching billing requests:", error);
    const errorMessage = error.response?.data?.message || "Error fetching billing requests";
    throw new Error(errorMessage);
  } finally {
    if (!silent) dispatch(setLoading(false));
  }
});

// PATCH /api/v1/cc/nursing_care/additional_consumables/:id/consumable_price
// Generates an Additional Billing quotation for a non-cash session
export const generateConsumableQuotation = createAsyncThunk("generateConsumableQuotation", async ({ id, quotation }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.patch(`/api/v1/cc/nursing_care/additional_consumables/${id}/consumable_price`, { quotation });
    return response.data;
  } catch (error) {
    console.error("Error generating quotation:", error);
    const errorMessage = error.response?.data?.message || "Error generating quotation";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

// POST /api/v1/cc/nursing_care/additional_consumables/:id/manual_payment
// Records a manual payment outcome — CASH collection or ABSCONDED
export const manualConsumablePayment = createAsyncThunk("manualConsumablePayment", async ({ id, type, amount }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/nursing_care/additional_consumables/${id}/manual_payment`, { type, amount });
    return response.data;
  } catch (error) {
    console.error("Error recording manual payment:", error);
    const errorMessage = error.response?.data?.message || "Error recording manual payment";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
